function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    viewBox: "210 0 540 540"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 10.45,
    d: "M297.076 470.466V69.272c168.428 98.248 206.839 122.252 345.18 201.996-106.74 62.263-197.709 113.175-345.18 199.198Z",
    style: {
      fill: "none",
      strokeWidth: 40,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgTriangle;